// PST-570 — GNB 응답 → HeaderVerticalItems 순수 파서.
// react-query/네트워크 의존 없음(SSR·CSR·테스트 어디서나 호출 가능).
// 17개 앱의 동일 파서 중복을 단일 소스로 흡수.

import { BadgeStyle, LocalNavVerticalItem, VerticalItem } from '../constants/lnb';
import { GnbResponse, GnbShortcut, HeaderVerticalItems } from './types';

/**
 * 1열 버티컬 그룹 ID(현행 17). 2열 프로모션 그룹 ID(현행 23).
 * 백엔드가 region×type 그룹을 내려주기 전까지는 분기에 사용하지 않고 폴백 동작한다.
 */
export const VERTICAL_GROUP_ID_1COL = 17;
export const VERTICAL_GROUP_ID_2COL = 23;

function toVerticalItem(shortcut: GnbShortcut): VerticalItem {
  return {
    id: shortcut.id,
    // 현 API 미제공 필드 — 기존 앱 파서와 동일한 placeholder 유지(추후 백엔드 확정 시 교체).
    code: 'TEST_CODE',
    title: shortcut.title,
    position: 0,
    badge: shortcut.badge,
    badge_style: shortcut.badgeStyle as BadgeStyle,
    cms_icon_id: 0,
    cms_icon_code: 'TEST_CODE',
    cms_icon_url: shortcut.iconImageUrl,
    level: 1,
    link: {
      mobile_web: shortcut.linkMoWeb,
      desktop: shortcut.linkWeb,
      mobile: shortcut.linkApp,
    },
  };
}

function toLocalNavVerticalItem(shortcut: GnbShortcut): LocalNavVerticalItem {
  return {
    id: shortcut.id,
    code: 'TEST_CODE',
    title: shortcut.title,
    lnb_required_badge: false,
    position: 0,
    level: 1,
    cms_icon_url: shortcut.iconImageUrl,
    link: {
      mobile_web: shortcut.linkMoWeb,
      desktop: shortcut.linkWeb,
    },
  };
}

/**
 * GNB 응답을 헤더 props 형태로 파싱한다.
 *
 * @param response GNB 응답(null 허용 — 실패/미수신 시 빈 배열).
 *
 * 현행 계약: 응답의 단일 그룹 shortcuts 를 1열(vertical_items)·2열(lnb_vertical_items)에 매핑.
 * region 분기는 fetch/쿼리키 단계에서 처리(discovery.ts); 백엔드가 region×type 그룹을 내려주면
 * 이 파서가 shortcuts[].groupId === VERTICAL_GROUP_ID_1COL / _2COL 로 분리하도록 확장한다.
 */
export function parseShortcutToVerticalItems(
  response: GnbResponse | null | undefined,
): HeaderVerticalItems {
  const shortcuts = response?.data?.shortCut?.shortcuts ?? [];

  return {
    vertical_items: shortcuts.map(toVerticalItem),
    sub_vertical_items: [],
    lnb_vertical_items: shortcuts.map(toLocalNavVerticalItem),
  };
}
